const AccountErrorsEnum = Object.freeze({
  UserNotFound: -1000,
  EmailNotExists: -1001,
  EmailAlreadyExists: -1002,
  InvalidPassword: -1003,
  FaliedCreateUserToken: -1004,
  MismatchedPassword: -1005,
  BusinessCustomerNotFound: -1006,
});

export default AccountErrorsEnum;
